/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC, Fragment } from "react";
import { useLocation } from "react-router";
import { useBooleanState } from "src/hooks/utils";
import MainSection from "../../MainSection";
import { NavMenuProps } from "../../NavMenu";
import RightSection from "../../RightSection";
import { CollapseContainer } from "../../styles";
import DetailNav from "../DetailNav";
import Hamburger from "../Hamburger";

const MobileAndTabletView: FC<NavMenuProps> = ({ hideLogin, moduleIds }) => {
  const { pathname } = useLocation();
  const [isNavOpen, toggleNav, _, closeNav] = useBooleanState(false);

  if (pathname === "/") {
    return (
      <Fragment>
        <Hamburger toggleNav={toggleNav} isToggled={isNavOpen} />
        <CollapseContainer visible={isNavOpen}>
          <MainSection moduleIds={moduleIds} closeNav={closeNav} />
        </CollapseContainer>
        <RightSection hideLogin={hideLogin} />
      </Fragment>
    );
  }

  return <DetailNav />;
};

export default MobileAndTabletView;
